import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-stone-50 py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-125" data-mp="1iw32ha07833a">
      <div className="mx-auto max-w-6xl px-4" data-id="element-126" data-mp="1dxt7p0idz4i7">
        <div className="text-center" data-id="element-127" data-mp="2bk8pk3eq646a">
          <span className="inline-flex items-center gap-2 rounded-md bg-emerald-800 px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-amber-300" data-id="element-128" data-mp="2bj7dpwpvxdni">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-129" data-mp="21m2nnlsx4y1f" /> Material completo para el aula
          </span>
          <h2 id="modules-title" className="mt-4 text-3xl font-extrabold text-emerald-950 sm:text-4xl" data-id="element-130" data-mp="1wnho7olhqie1">
            Los {totalVolumes} tomos del Megapack
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-131" data-mp="l7t2f0jz3pet">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.3,
            delay: index % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-xl border border-stone-200 bg-white shadow-sm shadow-stone-900/5" data-id="element-132" data-mp="1iw0bqdvay8fz" data-mpi={index}>
                <div className="flex min-h-[104px] items-center gap-4 bg-emerald-900 px-6 py-5" data-id="element-133" data-mp="14wiv4ls5u1hp">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-amber-500 text-emerald-950" data-id="element-134" data-mp="q7coicqzt8zs">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-135" data-mp="v5xnk8uidmmn" />
                  </span>
                  <div data-id="element-136" data-mp="h6et2iume9st">
                    <p className="text-[11px] font-extrabold uppercase tracking-[.18em] text-amber-300" data-id="element-137" data-mp="h7zk3yhq7alx">
                      Tomo {module.number}
                    </p>
                    <h3 className="mt-1 text-lg font-extrabold leading-tight text-stone-50" data-id="element-138" data-mp="2nvq843d2ru0l">{module.title}</h3>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-139" data-mp="2e42jea7wkr2t">
                  <p className="font-semibold text-stone-800" data-id="element-140" data-mp="2e29dix546avv">{module.subtitle}</p>

                  <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[.16em] text-stone-500" data-id="element-141" data-mp="296u3yhe53159">
                    ¿Qué resuelve en el aula?
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-stone-700" data-id="element-142" data-mp="31uy8v0ovza6w">{module.classroom}</p>

                  <ul className="mt-5 grid flex-1 content-start gap-2" data-id="element-143" data-mp="2wtsfr1rbdkwu">
                    {module.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-emerald-950" data-id="element-144" data-mp="2ssoxy9pphesz">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-700" aria-hidden="true" data-id="element-145" data-mp="1lgzqbxlzx8jy" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-6 rounded-lg border-l-4 border-amber-500 bg-emerald-50 p-4 text-sm leading-relaxed text-stone-900" data-id="element-146" data-mp="3szbz7mn1ziva">
                    <b className="font-extrabold text-emerald-900" data-id="element-147" data-mp="5wz0ea2o0918">Resultado: </b>
                    {module.result}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl bg-stone-800 px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-148" data-mp="flh2qvqleo6z">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-amber-300" data-id="element-149" data-mp="on71kmmt0pes">Colección principal</p>
          <p className="font-serif text-2xl font-extrabold tracking-tight text-stone-50 sm:text-3xl" data-id="element-150" data-mp="tm1i1hxau1vq">
            {totalVolumes} tomos premium <span className="mx-2 text-stone-400" data-id="element-151" data-mp="2qfmsp6b5gbkf">·</span> Contenido actualizado 2026
          </p>
        </div>
      </div>
    </section>;
}